import React, { useEffect, useState } from "react";

const RippleEffect = ({ isRippleVisible }: { isRippleVisible: boolean }) => {
  const [ripples, setRipples] = useState<number[]>([]);

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null;

    if (isRippleVisible) {
      // Start adding ripples at intervals
      let count = 0;
      const interval = setInterval(() => {
        setRipples((prevRipples) => [...prevRipples, count]);
        count++;
      }, 500);

      // Stop adding ripples after 3 seconds
      timer = setTimeout(() => {
        clearInterval(interval);
      }, 3000);

      // Cleanup intervals and timer
      return () => {
        clearInterval(interval);
        if (timer) clearTimeout(timer);
      };
    } else {
      // Reset ripple state if not visible
      setRipples([]);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isRippleVisible]);

  return (
    <>
      {ripples.map((ripple) => (
        <span
          key={ripple}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            // backgroundColor: "#2B244C",
            background: "radial-gradient(circle, transparent 50%, #2B244C 70%, transparent 100%)",

            opacity: 0.5,
            transform: "translate(-50%, -50%) scale(0)",
            animation: `ripple-animation 1.5s linear forwards`,
            animationDelay: `${ripple * 500}ms`,
          }}
        />
      ))}
      <style>{`
        @keyframes ripple-animation {
          0% {
            transform: translate(-50%, -50%) scale(2);
            opacity: 0.5;
          }
          50% {
            opacity: 0.3;
          }
          100% {
            transform: translate(-50%, -50%) scale(3);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
};

export default RippleEffect;
